// Finite technical IDs only. Source-contract tests bind this catalog to the backend graph.
export const TRACKING_NODES = {
  START: false,
  MENU: false,
  PAY_START: false,
  PAY_VZ_OPTIONS: false,
  PAY_VZ_BANK: false,
  PAY_TZ_CHECK: false,
  PAY_TZ_OFFER: false,
  PAY_TZ_REJECTED: true,
  PAY_TZ_COMPLETED: true,
  PAY_SEPA_FORM: false,
  PAY_TZ_SEPA_FORM: false,
  PAY_SEPA_CHECK: false,
  PAY_SEPA_ERROR: false,
  PAY_UE_BANK: false,
  PAY_TZ_UE_BANK: false,
  PAY_RZV_CONTRACT: false,
  PAY_RZV_RATE: true,
  PAY_RZV_MINCHECK: false,
  PAY_RZV_LOW: false,
  PAY_RZV_HARDSHIP_UPLOAD: false,
  PAY_RZV_HARDSHIP_CONTACT: false,
  PAY_RZV_HARDSHIP_TRANSFER: true,
  PAY_TRANSFER: true,
  PAY_CONTACT: false,
  DEFER_START: false,
  DEFER_INFO: false,
  DEFER_INPUT: false,
  DEFER_NOTICE: false,
  DEFER_CONTACT: false,
  DEFER_REJECTED: true,
  DEFER_TRANSFER: true,
  SETTLE_START: false,
  SETTLE_INFO: false,
  SETTLE_PAYMENT: false,
  SETTLE_INPUT: false,
  SETTLE_NOTICE: false,
  SETTLE_CONTACT: false,
  SETTLE_REJECTED: true,
  SETTLE_TRANSFER: true,
  SETTLE_ACCEPTED_PAYMENT: false,
  SETTLE_ACCEPTED_BANK: false,
  INFO_START: false,
  INFO_CLAIM: true,
  INFO_CLAIM_DETAIL: true,
  INFO_CONTACT: true,
  INFO_REQUEST_START: false,
  INFO_REQUEST_REASON: false,
  INFO_REQUEST_CONTACT: false,
  INFO_REQUEST_TIME: false,
  INFO_REQUEST_NOTICE: false,
  INFO_TRANSFER: true,
  INFO_RZV: true,
  RZV_ADJUST_START: false,
  RZV_ADJUST_COLLECT: false,
  RZV_ADJUST_TRANSFER: true,
  RZV_ADJUST_CONTACT: false,
  INFO_PAID_START: false,
  INFO_PAID_PROOF: false,
  INFO_PAID_PROOF_CONTACT: false,
  INFO_PAID_NO_PROOF_CONTACT: false,
  INFO_DELETE_START: false,
  INFO_DELETE_FORM: false,
  INFO_DELETE_CONTACT: false,
  INFO_TITLE_OBJECTION: false,
  INFO_GARNISHMENT: false,
  INFO_OBJECTION_START: false,
  INFO_OBJECTION_INFO: false,
  INFO_OBJECTION_PROOF: false,
  INFO_OBJECTION_CONTACT: false,
  INFO_DEFECT_START: false,
  INFO_DEFECT_DETAILS: false,
  INFO_DEFECT_PROOF: false,
  INFO_DEFECT_CONTACT: false,
  INFO_LEGAL: true,
  INFO_CREDIT_ROLE: true,
  RATENAUSSETZUNG_START: false,
  RATENAUSSETZUNG_INFO: false,
  RATENAUSSETZUNG_NOTICE: false,
  RATENAUSSETZUNG_CONFIRM: true,
  RATENAUSSETZUNG_CONFIRM_CONTACT: false,
  RATENAUSSETZUNG_TRANSFER: true,
  RATENAUSSETZUNG_CONTACT: false,
  FALSCHER_SCHULDNER_START: false,
  FALSCHER_SCHULDNER_PROOF: false,
  FALSCHER_SCHULDNER_TRANSFER: true,
  FALSCHER_SCHULDNER_CONTACT: false,
  UNKNOWN_STATE: false,
  STAMMDATEN_MODAL: false,
  CLOSING: true,
  DOCUMENT_UPLOAD_START: false,
  DOCUMENT_UPLOAD_READY: false,
  DOCUMENT_UPLOAD_TRANSFER: true,
  DOCUMENT_UPLOAD_CONTACT: false,
  INSOLVENCY_DONE: true,
  INSOLVENCY_MODAL: false,
} as const;
export type TrackingNode = keyof typeof TRACKING_NODES;
